RivalIQ.apps.Reports.module('models', function (models, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    models.Export = Backbone.Model.extend({
        getSpec: function () {
            const me = this;
            return me.get('data').spec || {};
        },
        getTitle: function () {
            const me = this;
            return me.getSpec().title || me.getSpec().filename || 'Report';
        },
        getIcon: function () {
            const me = this;
            return App.data.filetypes.get(me.get('export_type_id')).get('icon');
        },
        getDownloadPath: function () {
            const me = this;
            return `/api/landscape/${me.get('landscape_id')}/exports/${me.get('uuid')}`;
        },
        pollStatus: function () {
            const me = this;
            if (me.isBuilding()) {
                $.get(`/api/exportStatus?uuid=${me.get('uuid')}`).done(function (resp) {
                    me.set('export_status_id', _.head(resp));
                });

                me._pollTimeout = setTimeout(_.bind(me.pollStatus, me), 1000);
            }
        },

        isBuilding: function () {
            const me = this;
            return _.includes([App.enums.status.PENDING, App.enums.status.IN_PROGRESS], me.get('export_status_id'));
        },
        isFailed: function () {
            const me = this;
            return me.get('export_status_id') === App.enums.status.FAILED;
        },
        parse: function (attrs) {
            attrs.created_at = moment.utc(attrs.created_at);
            return attrs;
        },
        initialize: function (attrs, options) {
            const me = this;

            if (options.pollStatus) {
                me.pollStatus();
            }
        }
    });
}, window.moment);
